import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'context/themeContext';
import Currency from 'components/currency';
import Loading from 'components/loading';
import ImagePlaceholder from '../../asset/image-placeholder.svg';
import ErrorForAdminSVG from "asset/error-for-admin.svg";
import MainContext from 'MainContext';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { RFQBadge } from 'containers/dashboard/components/wrapper';

const Thumbnail = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.8));
`;

const ErrorForAdmin = styled.img.attrs({
  src: ErrorForAdminSVG,
})`
  width: 1.9vw;
  height: 1.9vw;
  position: absolute;
  top: 6.5vw;
  left:${(props) => props.rtlDirection ? '5.3vw' : '6.3vw'};
`;

const StyledTooltipContainer = styled.div`
  position: relative;
  // top: 4.3vw;
  top:${(props) => props.rtlDirection ? '3.9vw' : '4.1vw'};
  left:${(props) => props.rtlDirection ? '-4.2vw' : '4.6vw'};
  // left: 4.6vw;
  width: fit-content;
`;

const StyledTooltip = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.borderBackground};
  color: ${(props) => props.theme.textPrimary};
  padding: 0.3vw 0.56vw;
  border-radius: 0.6vw;
  font-weight: bold;
  font-size: 0.75vw;
`;

const StyledTooltipArrow = styled.div`
  position:relative;
  bottom: -0.66vw;
  // left: calc(50% - 0.5vw);
  left:${(props) => props.rtlDirection ? 'unset' : 'calc(50% - 0.5vw)'};
  right:${(props) => props.rtlDirection ? 'calc(50% - 0.5vw)' : 'unset'};
  width: 0;
  height: 0;
  border-left: 0.56vw solid transparent;
  border-right: 0.56vw solid transparent;
  border-top: 0.56vw solid ${(props) => props.theme.borderBackground};
`;

const MessageWrapper = styled.div`
  display:flex;
  align-items:center;
  border-radius:1.104vw;
  padding:0.21vw;
  background-color: ${(props) => props.notifications?.length > 0 && props.theme.baraRedColor};
`;

const MessageIcon = styled.div`
  margin-top: 0.15vw;
  margin-left: ${(props) => (props.rtlDirection ? 'unset' : '0.15vw')};
  margin-right: ${(props) => (props.rtlDirection ? '0.15vw' : 'unset')};

  display: flex;
  justify-content: center;
  color: #FFF;
  font-size: 1.1vw;
`;

const AttachIcon = styled.div`
  margin-left:${(props) => props.rtlDirection ? 'unset' : '0.1vw'};
  margin-right:${(props) => props.rtlDirection ? '0.1vw' : 'unset'};
  height:0.841vw;
  width:0.788vw;

  display: flex;
  justify-content: center;
  color: #FFF;
  font-size: 1vw;
`;

const AttachedFilesWrapper = styled.div`
  margin-right:${(props) => props.rtlDirection ? 'unset' : '0.525vw'};
  margin-left:${(props) => props.rtlDirection ? '0.525vw' : 'unset'};
  display:flex;
  align-items:center;
`;

const MessageNumber = styled.div`
  font-size:0.736vw;
  font-weight:400;
`;
const AttachedFilesNumber = styled.p`
  font-size:0.736vw;
  font-weight:400;
`;



const StyledImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  height: 13vw;
  width: 13.45vw;
`;

const StyledName = styled.div`
  position: absolute;
  bottom: 5.044vw;
  left: ${(props) => (props.rtlDirection ? 'unset' : '1.04vw')};
  right: ${(props) => (props.rtlDirection ? '1.04vw' : 'unset')};
  font-size: 0.728vw;
  width: calc(100% - 2.08vw);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const OrderMaterialAndColor = styled.div`
  position: absolute;
  bottom: 3.9vw;
  left: ${(props) => (props.rtlDirection ? 'unset' : '1.04vw')};
  right: ${(props) => (props.rtlDirection ? '1.04vw' : 'unset')};
  font-size: 0.624vw;
`;

const OrderQuality = styled.div`
  position: absolute;
  bottom: 2.394vw;
  left: ${(props) => (props.rtlDirection ? 'unset' : '1.04vw')};
  right: ${(props) => (props.rtlDirection ? '1.04vw' : 'unset')};
  font-size: 0.624vw;
`;

const Quantity = styled.div`
  position: absolute;
  right: ${(props) => (props.rtlDirection ? 'unset' : '1.04vw')};
  left: ${(props) => (props.rtlDirection ? '1.04vw' : 'unset')};
  top: 0.946vw;
  font-size: 0.7vw;
`;

const OrderPrice = styled.div`
  position: absolute;
  right: ${(props) => (props.rtlDirection ? 'unset' : '1.04vw')};
  left: ${(props) => (props.rtlDirection ? '1.04vw' : 'unset')};
  bottom: 1.04vw;
  font-size: 0.728vw;
`;

const NotificationWrapper = styled.div`
  position: absolute;
  left: ${(props) => (props.rtlDirection ? 'unset' : '0vw')};
  right: ${(props) => (props.rtlDirection ? '0vw' : 'unset')};
  top: 1.04vw;
`;


const LoadingWrapper = styled.div`
  position: absolute;
  right: 1.405vw;
  bottom: 1.717vw;
  height: 2.602vw;
  font-size: 0.728vw;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;
const AttachmentAndMessageWrapper = styled.div`
  position:absolute;
  top:${(props) => props.rtlDirection ? '0.18vw' : '0.3vw'};
  right:${(props) => props.rtlDirection ? '1.051vw' : 'unset'};
  left:${(props) => props.rtlDirection ? 'unset' : '1.051vw'};
  display:flex;
  align-items:center;
`;


const StyledOrder = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.cardBackground};
  height: 12.827vw;
  width: 13.244vw;
  border-radius: 1.9vw;
  margin-top: 0.78vw;
  box-sizing: border-box;
  font-size: 0.728vw;
  color: black;
  overflow: hidden;
  font-weight: 500;
  color: white;
  cursor: pointer;
  transform-origin: 0% 0%;
  transition: transform 200ms linear, box-shadow 200ms linear;
  z-index: 5;
  a {
    text-decoration: none;
  }
`;
const Image = styled.img.attrs({
  src: ImagePlaceholder,
})`
  position: absolute;
  top: 0;
  left: 0;
  height: 13vw;
  width: 13.45vw;
`;

const DownloadWrapper = styled.div`
position: absolute;
right: ${(props) => (props.rtlDirection ? 'unset' : '9.56vw')};
left: ${(props) => (!props.rtlDirection ? 'unset' : '9.56vw')};
top: 10.4vw;
width: 2.08vw;
height: 2.08vw;
background-color: ${(props) => props.theme.inputBackground + '00'};
border-radius: 50%;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
transition: 200ms linear;
transition: 200ms ease-in-out;
&:hover {
  background-color: ${(props) => props.theme.inputBackground};
}
`;

const DownloadIcon = styled.div`
  width: 1.1vw;
  height: 1.1vw;
  position: relative;
  transition: background-color 200ms linear;
  display: flex;
  justify-content: center;
  color: #FFF;
  font-size: 1.1vw;
`;

const Order = (props) => {
  const { theme, rtlDirection } = useContext(ThemeContext);
  const { t } = useTranslation();
  const { order, notifications } = props;
  const { attachments } = useContext(MainContext).orders;
  const [iconHover, setIconHover] = useState(false);
  const [messagesNumber, setMessagesNumber] = useState(0);
  const { orderId: orderIdFromParams } = useParams();


  useEffect(() => {
    if(!order.UIValues.loading && window.location.href.includes('/order/') && props.order._id === orderIdFromParams && !props.isOrderModalOpen){
        props.onOrderClick(props.order)
    }

  }, [props.order.UIValues.loading])

  console.log("1111111111", order)

  return (
    <>
    {order.UIValues.loading ? (
        <StyledOrder theme={theme} left={0} top={0} >
          <LoadingWrapper>
            <Loading width="5.101vw" height="1.249vw" borderRadius="0.728vw" />
            <Loading width="7.912vw" height="0.832vw" borderRadius="0.728vw" />
          </LoadingWrapper>
        </StyledOrder>
      ) : (
        <Link id={props.order._id}  style={{ textDecoration: 'none' }} to={`${props.link}/order/${props.order._id}`} draggable='false'>
          <StyledOrder theme={theme} 
          onClick={() => props.onOrderClick(order)}>
            {order.file.image_path === 'default image path' ? (
              <Image />
            ) : (
              <StyledImg
                src={`${process.env.REACT_APP_STATISTIC_SERVICE_URL}/stl` + order.file.image_path}
              />
            )} 
                    <Thumbnail />
                    <StyledName rtlDirection={rtlDirection}>{order.file.original_name}</StyledName>
                    {(order.status === 8 || order.status === 7) && ( 
                      <>  
                      <StyledTooltipContainer style={iconHover ? {} : {display: 'none'}} theme={theme} rtlDirection={rtlDirection}>
                        <StyledTooltip theme={theme} rtlDirection={rtlDirection}>
                          {order.status === 8 ? 'File Problem' : 'Failed Print'}
                          <StyledTooltipArrow theme={theme} rtlDirection={rtlDirection}/>
                        </StyledTooltip>
                      </StyledTooltipContainer> 
                      <ErrorForAdmin onMouseEnter={() => setIconHover(true)} onMouseLeave={() => setIconHover(false)} rtlDirection={rtlDirection}/> 
                      </>
                    )} 
                    <OrderMaterialAndColor rtlDirection={rtlDirection}>
                    {order.material.name + ' ' + order.color.name}
                  </OrderMaterialAndColor>
                  {order.material.material_type === 'time' && (
                    <OrderQuality>
                      {(order.quality.value*1000)+' '+t('microns')}
                      {
                      (order?.print_params?.infill_percentage!=undefined) &&
                        (<>- {order.print_params.infill_percentage}% {t('infill')}</>)
                      }
                      
                    </OrderQuality>
                  )}
                  <a href={`${process.env.REACT_APP_STATISTIC_SERVICE_URL}/stl/${order.file.original_file_path}?original_name=${order.file.original_name}`} >
                    <DownloadWrapper onClick={(e) => e.stopPropagation()} theme={theme} rtlDirection={rtlDirection} >
                      <DownloadIcon className="icon-second-download" theme={theme} />
                    </DownloadWrapper>
                  </a>
            <Quantity rtlDirection={rtlDirection}>{t('dashboard.table.invoice.QTY')} : {order.quantity}</Quantity>
            <OrderPrice rtlDirection={rtlDirection}>
              {/* <Currency value={order.price} /> this is changed to below one by qazal instead of the above line for preventing of floating point */}
              { order.status === 9 ?  
                <RFQBadge theme={theme}>RFQ</RFQBadge> : 
                <Currency
                  value={Number.isInteger(order.price) ? order.price : parseFloat(order.price).toFixed(2)}
                />
              }
              
            </OrderPrice>
            <AttachmentAndMessageWrapper rtlDirection={rtlDirection}>
              <AttachedFilesWrapper rtlDirection={rtlDirection}>
                <AttachedFilesNumber>{order.UIValues.attachmentsNO}</AttachedFilesNumber>
                <AttachIcon className="icon-attachfiles" theme={theme} rtlDirection={rtlDirection} />
              </AttachedFilesWrapper>
              <MessageWrapper theme={theme} notifications={notifications}>
                <MessageNumber>{order.UIValues.messagesNO}</MessageNumber>
                <MessageIcon className="icon-message-icon" theme={theme} rtlDirection={rtlDirection} />
              </MessageWrapper>
            </AttachmentAndMessageWrapper>
          </StyledOrder>
        </Link>
      )}
    </>
  );
};

export default Order;
